export class WidgetFilteredByClasses {

    static readonly text: string = "ic3WidgetFilteredBy-text";
    static readonly table: string = "ic3WidgetFilteredBy-table";

}

export declare type WidgetFilteredByClassesKey = keyof WidgetFilteredByClasses;